import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { ID } from "utils/id";

export interface Data {
  status: {
    message: string;
  };
}

export interface Variables {
  id: ID;
}

export const MUTATION = gql`
  mutation deleteMeetingRecord($id: ID!) {
    status: deleteMeetingRecord(id: $id) {
      message
    }
  }
`;
export const useDeleteMeetingRecordMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;

  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "searchMeetingInstanceRecords",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };
  return useMutation<Data, Variables>(MUTATION, options);
};
